import { render } from "./VitTabs.vue?vue&type=template&id=d8aaec90&ts=true"
import script from "./VitTabs.vue?vue&type=script&lang=ts"
export * from "./VitTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__